<script setup lang="ts">
import { RouterLink } from 'vue-router';
import type { TopMenuChildLink, TopMenuLinkView } from '@/nav/menuModel';

defineProps<{
  activeMegaItem: TopMenuLinkView;
  children: TopMenuChildLink[];
  megaIntro: string;
  isActive: (url: string) => boolean;
  /** Grace-period hint: panel may close if pointer does not return. */
  closingSoon?: boolean;
}>();

defineEmits<{
  'mega-enter': [];
  'mega-leave': [];
  'focus-in': [];
  'nav-click': [];
}>();
</script>

<template>
  <div
    id="desktop-mega-panel"
    class="side-nav__desktop-mega"
    :class="{ 'side-nav__desktop-mega--closing-soon': closingSoon }"
    role="region"
    :aria-label="activeMegaItem.label"
    @mouseenter="$emit('mega-enter')"
    @mouseleave="$emit('mega-leave')"
    @focusin="$emit('focus-in')"
  >
    <div class="side-nav__desktop-mega-inner">
      <div class="side-nav__desktop-mega-col side-nav__desktop-mega-col--intro">
        <RouterLink
          :to="activeMegaItem.path"
          class="side-nav__desktop-mega-head"
          @click="$emit('nav-click')"
        >
          <div class="side-nav__desktop-mega-icon-wrap" aria-hidden="true">
            <component :is="activeMegaItem.icon" class="side-nav__desktop-mega-icon" />
          </div>
          <div class="side-nav__desktop-mega-head-text">
            <h3 class="side-nav__desktop-mega-title">
              {{ activeMegaItem.label }}
            </h3>
            <p class="side-nav__desktop-mega-tagline">
              {{ megaIntro }}
            </p>
          </div>
        </RouterLink>
      </div>
      <div class="side-nav__desktop-mega-col side-nav__desktop-mega-col--links">
        <RouterLink
          v-for="child in children"
          :key="child.path"
          :to="child.path"
          class="side-nav__desktop-mega-card"
          :class="{
            'side-nav__desktop-mega-card--active': isActive(child.path),
          }"
          :aria-current="isActive(child.path) ? 'page' : undefined"
          @click="$emit('nav-click')"
        >
          <span class="side-nav__desktop-mega-card-title">{{ child.label }}</span>
        </RouterLink>
      </div>
    </div>
  </div>
</template>
